/**
 * ChessPiece component exports
 */

import ChessPiece from './ChessPiece';

export default ChessPiece; 